// extracted by mini-css-extract-plugin
export default {"wrap":"QK-z","fullWidth":"RK-z","hideOnDesktop":"SK-z","content":"TK-z","hasOpenedNav":"UK-z","crumbsList":"VK-z","dropdownsWrap":"WK-z"};